import { render, staticRenderFns } from "./Castigo.vue?vue&type=template&id=6c4570c0&"
import script from "./Castigo.vue?vue&type=script&lang=js&"
export * from "./Castigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports